module.exports = __webpack_public_path__ + "static/img/Illustration.3a1d3dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Illustration.svg
// module id = 3lGl
// module chunks = 1